// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-documents-preview-pdf-page-styles__docsUiPreviewPage--2SC5Q section {\n  position: absolute;\n  color: black;\n  font-size: 10px;\n}\n", ""]);
// Exports
exports.locals = {
	"docsUiPreviewPage": "src-documents-preview-pdf-page-styles__docsUiPreviewPage--2SC5Q"
};
module.exports = exports;
